<script setup>
import { useNotify } from '../composables/notification'
import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  ExclamationCircleIcon,
} from '@heroicons/vue/24/outline'
import { XMarkIcon } from '@heroicons/vue/20/solid'
import { SUCCESS, ERROR, INFO } from '../constants/notificationTypes'

const notify = useNotify()
</script>

<template>
  <Teleport to="#notification">
    <div
      aria-live="assertive"
      class="pointer-events-none fixed inset-0 z-50 flex flex-col items-end gap-y-2 px-4 py-6 sm:items-start sm:p-6"
    >
      <div
        v-for="(_, index) in 5"
        :key="index"
        class="flex w-full flex-col items-center space-y-4 sm:items-end"
      >
        <transition
          enter-active-class="transition duration-300 ease-out transform"
          enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
          leave-active-class="transition duration-100 ease-in"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="notify.notifications.value[index]"
            class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5"
          >
            <div class="p-4">
              <div class="flex items-start">
                <div class="flex-shrink-0">
                  <CheckCircleIcon
                    v-if="notify.notifications.value[index]?.type === SUCCESS"
                    class="h-6 w-6 text-green-400"
                    aria-hidden="true"
                  />
                  <ExclamationTriangleIcon
                    v-if="notify.notifications.value[index]?.type === ERROR"
                    class="h-6 w-6 text-red-400"
                    aria-hidden="true"
                  />
                  <ExclamationCircleIcon
                    v-if="notify.notifications.value[index]?.type === INFO"
                    class="h-6 w-6 text-yellow-400"
                    aria-hidden="true"
                  />
                </div>
                <div class="ml-3 w-0 flex-1 pt-0.5">
                  <p class="text-sm font-medium text-gray-900">
                    {{ notify.notifications.value[index]?.title }}
                  </p>
                  <p class="mt-1 text-sm text-gray-500">
                    {{ notify.notifications.value[index]?.description }}
                  </p>
                </div>
                <div class="ml-4 flex flex-shrink-0">
                  <button
                    type="button"
                    class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    @click="notify.removeNotification(index)"
                  >
                    <span class="sr-only">Close</span>
                    <XMarkIcon class="h-5 w-5" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </Teleport>
</template>
